import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { stylesUrl } from './app/shared/services/client-config';

// Inyecta el CSS específico del cliente antes de arrancar Angular.
// Se carga como <link> en lugar de a través del bundle para que pueda
// variar entre clientes sin recompilar.
const themeLink = document.createElement('link');
themeLink.rel = 'stylesheet';
themeLink.href = stylesUrl();
themeLink.setAttribute('data-client-theme', '');
document.head.appendChild(themeLink);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
